import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';

const fmt = (v) => (v != null ? Number(v).toLocaleString('ru-RU') : '—');

export default function MvpAvitoListings({ clientId }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    apiClient.get('/mvp/avito-listings', { params: { client_id: clientId } })
      .then(({ data: d }) => { if (!cancelled) setData(d); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [clientId]);

  if (loading) return <p className="text-[var(--wb-text-muted)]">Загрузка объявлений…</p>;

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Авито — объявления и продвижение</h2>
      <p className="text-sm text-[var(--wb-text-muted)]">
        Статистика объявлений и ставки продвижения в выдаче (демо)
      </p>
      <div className="wb-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[var(--wb-surface-muted)]">
            <tr>
              <th className="p-3 text-left">Объявление</th>
              <th className="p-3">Город</th>
              <th className="p-3">Цена</th>
              <th className="p-3">Просмотры</th>
              <th className="p-3">Контакты</th>
              <th className="p-3">Ставка</th>
              <th className="p-3">Позиция</th>
            </tr>
          </thead>
          <tbody>
            {(data?.items || []).map((row) => (
              <tr key={row.item_id} className="border-t border-[var(--wb-border)]">
                <td className="p-3">
                  <div className="font-medium">{row.title}</div>
                  <div className="text-xs text-[var(--wb-text-muted)]">{row.category}</div>
                </td>
                <td className="p-3">{row.city}</td>
                <td className="p-3">{fmt(row.price)} ₽</td>
                <td className="p-3">{fmt(row.views)}</td>
                <td className="p-3">{fmt(row.contacts)}</td>
                <td className="p-3">{row.bid_kopecks ? `${(row.bid_kopecks / 100).toFixed(0)} ₽` : '—'}</td>
                <td className="p-3">{row.position ?? '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
